export default __webpack_public_path__ + "static/media/Control.c6011108.jpg";